/**
 * Tenant context types.
 * Business knowledge entries injected into LLM primitives at execution time.
 */

export interface TenantContextEntry {
  id: string;
  tenant_id: string;
  category: string;
  title: string;
  content: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface ContextCategoryMeta {
  key: string;
  label: string;
  description: string;
}

export const CONTEXT_CATEGORIES: readonly ContextCategoryMeta[] = [
  { key: 'company_info', label: 'Entreprise', description: 'Qui vous êtes et ce que vous apportez.' },
  { key: 'product', label: 'Offre', description: 'Ce que vous vendez, à quel prix, et ce qui déclenche le rendez-vous.' },
  { key: 'personas', label: 'Cible et exclusions', description: 'Les entreprises et décideurs à viser, les critères, et celles à écarter.' },
  { key: 'sales_process', label: 'Processus commercial', description: 'Rendez-vous qualifié, étapes du pipeline, canaux.' },
  { key: 'tone_of_voice', label: 'Ton', description: 'Comment écrire aux prospects et aux clients.' },
] as const;

export type ContextCategoryKey = typeof CONTEXT_CATEGORIES[number]['key'];
